var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrellaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8819_10530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.675 29.0362L34.8749 50.4112C34.5372 51.3862 33.4499 51.9113 32.4749 51.5362C31.4999 51.1988 31.0124 50.1112 31.3499 49.1363L39.15 27.7238C39.5249 26.7488 40.575 26.2613 41.5499 26.5988C42.5249 26.9737 43.05 28.0613 42.675 29.0362Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.675 29.0389L34.8749 50.4139C34.5372 51.3889 33.4499 51.9141 32.4749 51.5389L41.5499 26.6016C42.5249 26.9764 43.05 28.0641 42.675 29.0389Z",
    fill: "#3C3A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3251 9.79797C23.7999 12.3795 19.3236 17.5847 18.3001 20.148C18.3001 20.4603 17.4133 21.6842 16.725 23.5606C16.3876 24.5356 16.8751 25.6231 17.8501 25.9606C18.8249 26.3355 19.9126 25.8105 20.25 24.8355C20.475 24.2356 20.8126 23.7105 21.0751 23.1481L31.6501 27.0105L47.9625 9.0106C41.8499 6.76047 35.2499 7.06047 29.3251 9.79797Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7249 21.6116C58.9875 15.6866 54.075 11.2241 47.9625 9.01172L48.9 33.2741L59.5876 37.1742C59.4 37.7741 59.25 38.3742 59.025 38.9741C58.6501 39.9116 59.1749 40.999 60.15 41.3741C60.3375 41.449 60.5625 41.4865 60.7874 41.4865C61.5374 41.4865 62.2499 40.999 62.55 40.2491C64.708 33.9703 64.4768 27.4883 61.7249 21.6116Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 1.875V5.75C11.375 6.79988 10.5501 7.625 9.5 7.625C8.44987 7.625 7.625 6.79988 7.625 5.75V1.875C7.625 0.824875 8.44987 0 9.5 0C10.5501 0 11.375 0.824875 11.375 1.875Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 13.25V17C11.375 18.0499 10.5501 18.875 9.5 18.875C8.44987 18.875 7.625 18.0499 7.625 17V13.25C7.625 12.1999 8.44987 11.375 9.5 11.375C10.5501 11.375 11.375 12.1999 11.375 13.25Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24989 9.49812C5.93126 9.49812 5.60901 9.4175 5.31426 9.24725L2.06776 7.37225C1.17052 6.85412 0.86289 5.70787 1.38114 4.81062C1.89939 3.91162 3.04739 3.604 3.94276 4.124L7.18926 5.999C8.08651 6.51725 8.39414 7.66337 7.87589 8.56062C7.52801 9.163 6.89814 9.49812 6.24989 9.49812Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 14.875L11.8107 13C10.9135 12.4817 10.6059 11.3356 11.1241 10.4383C11.6405 9.53745 12.7885 9.23533 13.6857 9.7517L16.9322 11.6267C17.8295 12.145 18.1371 13.2911 17.6189 14.1883C17.0994 15.088 15.9496 15.3905 15.0572 14.875Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38114 14.1883C0.86289 13.2911 1.17052 12.1448 2.06776 11.6267L5.31426 9.7517C6.20414 9.23533 7.35589 9.53745 7.87589 10.4383C8.39414 11.3356 8.08651 12.4818 7.18926 13L3.94276 14.875C3.04864 15.3915 1.89977 15.0863 1.38114 14.1883Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 9.49812C12.1019 9.49812 11.472 9.163 11.1241 8.56062C10.6059 7.66337 10.9135 6.51712 11.8107 5.999L15.0572 4.124C15.949 3.604 17.097 3.91162 17.6189 4.81062C18.1371 5.70787 17.8295 6.85412 16.9322 7.37225L13.6857 9.24725C13.391 9.4175 13.0687 9.49812 12.7501 9.49812Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 1.875V5.75C11.375 6.79988 10.5501 7.625 9.5 7.625V0C10.5501 0 11.375 0.824875 11.375 1.875Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 13.25V17C11.375 18.0499 10.5501 18.875 9.5 18.875V11.375C10.5501 11.375 11.375 12.1999 11.375 13.25Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.875C6.38738 3.875 3.875 6.38738 3.875 9.5C3.875 12.6124 6.38738 15.125 9.5 15.125C12.6126 15.125 15.125 12.6124 15.125 9.5C15.125 6.38738 12.6126 3.875 9.5 3.875Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 9.5C15.125 12.6124 12.6126 15.125 9.5 15.125V3.875C12.6126 3.875 15.125 6.38738 15.125 9.5Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.25 62.125H3.75C3.75 54.625 15.9499 48.875 32 48.875C48.0501 48.875 60.25 54.625 60.25 62.125Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.25 62.125H32V48.875C48.0501 48.875 60.25 54.625 60.25 62.125Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 62.125C64 63.1749 63.1751 64 62.125 64H1.875C0.824875 64 0 63.1749 0 62.125C0 61.0749 0.824875 60.25 1.875 60.25H62.125C63.1751 60.25 64 61.0749 64 62.125Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 62.125C64 63.1749 63.1751 64 62.125 64H32V60.25H62.125C63.1751 60.25 64 61.0749 64 62.125Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9 33.2748C48.5999 33.9498 48.2626 34.5874 47.925 35.2249C47.475 36.0873 46.3876 36.5001 45.375 35.9749C44.475 35.4499 44.1374 34.3249 44.625 33.4249C44.8875 32.9749 45.15 32.4874 45.3375 31.9999L40.275 30.1249L35.2126 28.2874C35.0625 28.8123 34.9501 29.2998 34.8375 29.8248C34.65 30.8749 33.6375 31.5123 32.6251 31.3249C31.6125 31.1373 30.9376 30.1249 31.1626 29.1123C31.275 28.4373 31.4251 27.7248 31.6501 27.0123C33.3376 19.2122 40.8001 6.38731 47.9625 9.01231C55.0875 11.5624 52.65 26.0373 48.9 33.2748Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9 33.2741C48.5999 33.9491 48.2626 34.5867 47.925 35.2242C47.475 36.0866 46.3876 36.4993 45.375 35.9742C44.475 35.4492 44.1374 34.3242 44.625 33.4242C44.8875 32.9742 45.15 32.4867 45.3375 31.9992L40.275 30.1242L47.9625 9.01172C55.0875 11.5617 52.65 26.0366 48.9 33.2741Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8819_10530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrellaIcon);
export default __webpack_public_path__ + "static/media/umbrella-icon.997054f054188345815c1ebdf1e765f6.svg";
export { ForwardRef as ReactComponent };